<div class="reelax-white-bg" *transloco="let t">
  <div class="page-container mb-0 pb-5">

    <h1 class="title --page mt-0 pt-5 mb-5">{{ t('help.FAQ') }}</h1>

    @if (faqSection) {
      <div class="faq">
        <div class="faq__tabs">
          @for (tab of tabs; track tab) {
            <a
              class="full-tab-link"
              [routerLink]="['../', tab.route]"
              routerLinkActive="--active fw-700"
              #rla="routerLinkActive"
              >
              @if (rla.isActive) {
                <mat-icon>keyboard_arrow_right</mat-icon>
              }
              {{ t('help.' + tab.value) | titlecase }}
            </a>
          }
        </div>
        <div class="faq__content">
          <app-faq-content [fragment]="currentFragment" [faqSections]="[faqSection]"/>
        </div>
      </div>
    }

    <p class="text center">
      <span class="fw-700">{{ t('help.noAnswer') }}</span><br>
      {{ t('help.weWillAnswer') }}
    </p>

    <div class="buttons-group --row small-container --full-width px-0 ">
      <a
        routerLink="/contact"
        [queryParams]="faqSection === FaqSection.Organizer ?
        {
          subject: 'organizer',
        } : {}"
      >
        <button mat-button class="button --primary --full-width --small">
          {{ t('common.contactUs') }}
        </button>
      </a>
    </div>
  </div>
</div>